import Icon from "../Icon";
import { Spinner } from "./estado";

/* -------------------------------- CARD -------------------------------- */
export function Card({
  title,
  subtitle,
  actions,
  children,
  pad = true,
  className = "",
}) {
  return (
    <section className={`card ${className}`}>
      {(title || actions) && (
        <header className="card-head">
          <div className="grow" style={{ minWidth: 0 }}>
            {title && <h2 className="card-title">{title}</h2>}
            {subtitle && <p className="card-sub">{subtitle}</p>}
          </div>
          {actions}
        </header>
      )}
      {pad ? <div className="card-pad">{children}</div> : children}
    </section>
  );
}


/* -------------------------------- TABS -------------------------------- */
export function Tabs({ value, onChange, items }) {
  return (
    <div className="tabs" role="tablist">
      {items.map((t) => (
        <button
          key={String(t.value)}
          role="tab"
          aria-selected={t.value === value}
          onClick={() => onChange(t.value)}
        >
          {t.label}
          {t.count !== undefined && (
            <span className="nav-count" style={{ marginLeft: 8 }}>
              {t.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}


/* ------------------------------- CABECERA ----------------------------- */
export function PageHead({ title, description, children }) {
  return (
    <header className="page-head">
      <div>
        <h1 className="page-title">{title}</h1>
        {description && <p className="page-desc">{description}</p>}
      </div>
      {children && <div className="page-actions">{children}</div>}
    </header>
  );
}


/* ------------------------------- ACCIONES ----------------------------- */

/**
 * Botón de acción con icono en pastilla y subtítulo opcional.
 *
 * En un pie de diálogo conviven acciones de peso muy distinto (cerrar,
 * cambiar un turno, bloquear una cuenta). Con todos iguales hay que leer el
 * texto de cada uno para saber cuál es grave; el tono y el icono lo dicen
 * antes de leer.
 */
export function ActionButton({
  icon,
  tone = "brand",
  children,
  sub,
  busy = false,
  disabled = false,
  onClick,
  title,
}) {
  return (
    <button
      type="button"
      className={`btn-accion tono-${tone}`}
      onClick={onClick}
      disabled={disabled || busy}
      title={title}
    >
      <i>{busy ? <Spinner size={14} /> : <Icon name={icon} size={15} />}</i>
      <span style={{ textAlign: "left" }}>
        {children}
        {sub && <span className="btn-accion-sub">{sub}</span>}
      </span>
    </button>
  );
}
